import React from 'react';
import './ServicePage.css';

import { Heading, Service, PageTitle } from '../../../components';
import { services } from '../../../constants';



const ServicePage = () => { 

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Services'} page={'Services'} />

      <section className='services'>

        {/* Section heading */}
        <Heading title={'our services'} subTitle={'what we offer'} />

        <div className='box-container'>

          {/* Map over the services array to render each service */}
          {services.map((service) => { 
            return (
              <Service key={service.id} service={service} />
            );
          })}
        </div>

      </section>

    </>

  )
}

export default ServicePage;